__turbopack_context__.v({
  "backHome": "snNjSa_backHome",
  "buttonsWrapper": "snNjSa_buttonsWrapper",
  "errorDecisionLabel": "snNjSa_errorDecisionLabel",
  "orderDetailsItem": "snNjSa_orderDetailsItem",
  "orderDetailsItemLabel": "snNjSa_orderDetailsItemLabel",
  "orderDetailsItemValue": "snNjSa_orderDetailsItemValue",
  "orderDetailsWrapper": "snNjSa_orderDetailsWrapper",
  "orderNumber": "snNjSa_orderNumber",
  "payment": "snNjSa_payment",
  "repeatOrder": "snNjSa_repeatOrder",
  "subtitle": "snNjSa_subtitle",
  "title": "snNjSa_title",
  "wrapper": "snNjSa_wrapper",
});
